import { useEffect, useRef } from "react";

// Loads the JuicyAds library once, then renders a fixed-size ad zone.
// Usage: <AdBanner zone="1121861" width={300} height={100} />
// Ads only fill (and the jads.js script is only loaded) on the approved
// production domain — on preview/dev we render a placeholder so the ad
// network script can't throw and block QA.
const AD_HOSTS = ["kinkvault.online", "www.kinkvault.online"];
const adsEnabled = () => typeof window !== "undefined" && AD_HOSTS.includes(window.location.hostname);

let scriptRequested = false;
function ensureJuicyScript() {
  if (scriptRequested || document.querySelector('script[src*="poweredby.jads.co"]')) {
    scriptRequested = true;
    return;
  }
  const s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.setAttribute("data-cfasync", "false");
  s.src = "https://poweredby.jads.co/js/jads.js";
  document.body.appendChild(s);
  scriptRequested = true;
}

export default function AdBanner({ zone = "1121861", width = 300, height = 100, className = "" }) {
  const pushed = useRef(false);

  useEffect(() => {
    if (!adsEnabled()) return;
    ensureJuicyScript();
    const t = setTimeout(() => {
      if (pushed.current) return;
      try {
        (window.adsbyjuicy = window.adsbyjuicy || []).push({ adzone: Number(zone) });
        pushed.current = true;
      } catch (e) {
        /* jads not ready yet — will fill on next load */
      }
    }, 400);
    return () => clearTimeout(t);
  }, [zone]);

  if (!adsEnabled()) {
    return (
      <div data-testid="ad-banner" className={`flex flex-col items-center justify-center py-6 ${className}`}>
        <span className="font-mono text-[8px] uppercase tracking-[0.25em] text-[#52525B] mb-2">Advertisement</span>
        <div style={{ width, height }} className="flex items-center justify-center bg-[#020202] border border-[#1C1C1F] rounded-md text-[#52525B] text-xs text-center px-3">
          Ads show on the live site
        </div>
      </div>
    );
  }

  return (
    <div data-testid="ad-banner" className={`flex flex-col items-center justify-center py-2 ${className}`}>
      <span className="font-mono text-[8px] uppercase tracking-[0.25em] text-[#52525B] mb-1.5">Advertisement</span>
      <ins
        id={String(zone)}
        data-width={String(width)}
        data-height={String(height)}
        style={{ display: "inline-block", width, height, background: "#020202", border: "1px solid #1C1C1F" }}
      />
    </div>
  );
}
